module.exports = __webpack_public_path__ + "static/media/login_pic.c3bd2922.jpeg";